<template>
  <div class="decoration-page">
    <div class="designer-cnt" @click.self="cancelSelect">
      <!-- 左侧 -->
      <div class="manage_left">
        <div ref="displaybody" class="display-body">
          <div class="cardDrag-container common-container" v-if="compList2[attrItemDataIndex]">
            <shopNav :compData="compList2[attrItemDataIndex].assemblyAttr"/>
          </div>
        </div>
        <div id="targetEl" ref="targetEl" class="targetEl">
          <el-button type="success" @click="handleRenovationDetailSave">保存</el-button>
          <!-- <el-button type="warning" @click="handleAssemblySave">Save</el-button> -->
        </div>
      </div>
      <!-- 左侧 -->
      <!-- 右侧 -->
      <div class="attr-layer">
        <div class="attr-detail">
          <div class="" v-if="compList2[attrItemDataIndex]">
            <shopNavAttr v-model="compList2[attrItemDataIndex].assemblyAttr" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
// 模板样式
import {
  shopNav
} from './components/index'
// 模板配置
import {
  shopNavAttr
} from './components/index'
export default {
  components: {
    shopNav,
    shopNavAttr,
  },
  data () {
    return {
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        currPage: 1,
        condition: {}
      },
      form: {},
      selected: true,
      decorateClassIndex: 0, // 当前分类序号
      curDecorateClass: {}, // 当前分类
      decorateClassList: [], // 装修分类
      decorateAssemblyList: [], // 装修组件
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      radio: '1',
      activeCollapse: ['1', '2', '3'],
      compList2: [
      ],
      groupLeft: {
        name: 'itxst',
        pull: 'clone', // 拖出 true, false, 'clone', array , function
        put: false // 拖入
      },
      groupCenter: {
        name: 'itxst',
        pull: false, // 拖出
        put: true // 拖入
      },
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      computedStyle: {},
      attrItemDataIndex: 0,
      assemblyAttr: [],
      shopNavBasicOption:[],
      merchantCode: JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.merchantCode
    }
  },

  created () {
    // this.getCurDecorateClass()
    this.getAssemblyList()
  },

  mounted () {
    // this.$nextTick(() => {
    //   // 获取定义ref属性 和 元素高度
    //   // this.headerHeight = this.$refs.search_d.offsetHeight;
    //   window.addEventListener('resize', this.getHeight())
    // })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },
    // 点击 中间 组件
    handleCClick (e, index) {
      this.attrItemDataIndex = index
      this.selected = true
    },
    // 点击 右侧 组件
    handleRClick (e, index) {
      this.attrItemDataIndex = index
      this.selected = true
    },
    // 移动 中间 开始
    handleCStart (e) {
      this.attrItemDataIndex = e.oldIndex
    },
    // 移动 右侧 开始
    handleRStart (e) {
      this.attrItemDataIndex = e.oldIndex
    },
    // 取消选中
    cancelSelect () {
      this.selected = false
    },
    // 获取随机数
    randomNumber () {
      const rm = Math.floor(Math.random() * 10e7)
      return rm
    },


    // 获取 装修分类
    getClassList () {
      var that = this
      const _data = {
        isUse: 2,// 是否上架 1 是 2 否
        "renovationCode": "shopnavManage",
      }
      that.$http.post('/renovationClass/queryClass', _data).then(function (response) {
        if (response.data.code == 200) {
          that.decorateClassList = response.data.data
          that.curDecorateClass = response.data.data?.[0] || {}
          that.decorateClassIndex = 0
          that.getCurDecorateClass()
        }
      })
    },
    // 获取 装修组件
    getAssemblyList () {
      var that = this
      const _data = {
        assemblyType: 9,//组件类型 1：基本组件 2：营销组件, 9：导航组件
      }
      that.$http.post('/renovationAssembly/queryList', _data).then( (response) => {
        if (response.data.code == 200) {
          that.decorateAssemblyList = response.data.data
          that.shopNavBasicOption = response.data.data.filter(item => item.assemblyType == 9)

          that.getCurDecorateClass()
        }
      })
    },

    // 获取 装修分类详情
    getCurDecorateClass () {
      var that = this
      const _data = {
        renovationCode: 'shopnavManage',//this.curDecorateClass.renovationCode,// 装修编码
        merchantCode: this.merchantCode
      }
      that.compList2 = []
      that.$http.post('/merchantTabbarDetail/queryList', _data).then((response) => {
        if (response.data.code == 200) {
          if(response.data.data.length>0){
            that.compList2 = response.data.data.map(item => {
              return {
                ...item,
                assemblyAttr: JSON.parse(item.assemblyAttr),
                sortId: item.id + ''
              }
            })
          }else {
            that.compList2 = [...that.shopNavBasicOption].map(item => {
              const _ddd = {
                ...item,
                assemblyAttr: JSON.parse(item.assemblyAttr),
                sortId: item.id + ''
              }
              delete _ddd.id
              return _ddd
            })
          }
          console.log('compList2', that.compList2,that.shopNavBasicOption)
        }
      })
    },

    // 保存 组件默认配置
    handleAssemblySave () {
      var that = this
      console.log('??--0', that.decorateAssemblyList)
      this.$confirm(`确定更新 ${that.decorateAssemblyList[0].assemblyName} 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(confirm => {
        const _data = {
          id: that.decorateAssemblyList[0].id,
          assemblyAttr: JSON.stringify(
            {
              attr: {
                a0: {
                  label: '样式选择',
                  value: '1',
                  type: 'data',
                  showList: {
                    '1': '标准版',
                    '2': '主图标版',
                    '3': '悬浮窗版',
                  },
                  selectOption: {
                    keys: ['1', '2', '3'],
                    values: ['标准版', '主图标版', '悬浮窗版']
                  },
                },
                a1: {
                  label: '仅选中时展示图标',
                  value: '0',
                  key: 'goodsStyle',
                  type: 'data',
                },
                a2: {
                  label: '编辑导航',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/classify.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/classify-active.png',//选中
                      name: '分类',
                      url: '',
                      key: 'classify',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/cart.png',
                      img1: 'http://146.56.248.225/resources/img/cart-active.png',
                      name: '购物车',
                      url: '',
                      key: 'cart',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/my.png',
                      img1: 'http://146.56.248.225/resources/img/my-active.png',
                      name: '我的',
                      url: '',
                      key: 'my',
                    }
                  ],
                  type: 'data',
                },
                a3: {
                  label: '应用页面',
                  value: [true,true],
                  type: 'data',
                  checkboxList: ['店铺主页','个人中心']
                },

                a4: {
                  label: '导航图标色',
                  value: '2',
                  sid: 'goods_weapp_s12',
                  showList: {
                    '1': '自定义模式',
                    '2': '系统默认'
                  },
                  key: 'goodsTag',
                  type: 'style',
                  tag: 'radio'
                },
                a5: {
                  label: '未选中',
                  value: '#666666',
                  sid: 'attr_s',
                  showList: {},
                  default: '#666666',
                  key: 'background',
                  type: 'style',
                  tag: 'ColorPicker'
                },
                a6: {
                  label: '选中',
                  value: '#FF4444',
                  sid: 'attr_s',
                  showList: {},
                  default: '#FF4444',
                  key: 'background',
                  type: 'style',
                  tag: 'ColorPicker'
                },

                b1: {
                  label: '主窗口',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                  ],
                  type: 'data',
                },
                b2: {
                  label: '编辑导航',
                  value: [
                    {
                      img0: 'http://146.56.248.225/resources/img/index.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/index-active.png',//选中
                      name: '首页',
                      url: '',
                      key: 'home',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/classify.png',//未选中
                      img1: 'http://146.56.248.225/resources/img/classify-active.png',//选中
                      name: '分类',
                      url: '',
                      key: 'classify',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/cart.png',
                      img1: 'http://146.56.248.225/resources/img/cart-active.png',
                      name: '购物车',
                      url: '',
                      key: 'cart',
                    },
                    {
                      img0: 'http://146.56.248.225/resources/img/my.png',
                      img1: 'http://146.56.248.225/resources/img/my-active.png',
                      name: '我的',
                      url: '',
                      key: 'my',
                    }
                  ],
                  type: 'data',
                },
                b3: {
                  label: '导航图标色',
                  value: '2',
                  showList: {
                    '1': '自定义模式',
                    '2': '系统默认'
                  },
                  key: 'goodsTag',
                  type: 'style',
                  tag: 'radio'
                },
              },
              attrsort: [
                'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrsort1: [
                'b1', 'b2', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrsort2: [
                'a0', 'a1', 'a2', 'a3', 'a4', 'a5', 'a6'
              ],
              attrType: ['attrsort', 'attrsort1', 'attrsort2']
            }
          )

        }
        // 与店铺风格一致 系统默认
        that.$http.post('/renovationAssembly/update', _data).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '保存成功',
              showClose: true
            })
            // that.getAssemblyList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        }).catch(function (error) {
        })
      }).catch( (error) => {
      })
    },
    // 保存分类配置
    handleRenovationDetailSave (_boolean) {
      var that = this
      this.$confirm('确定保存分类配置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(confirm => {
        const _data = that.compList2.map((item, index) => {
          return {
            ...item,
            assemblyAttr: JSON.stringify(item.assemblyAttr),
            renovationCode: 'shopnavManage',//that.curDecorateClass.renovationCode,
            orderSq: index + 1,
            merchantCode: that.merchantCode,
          }
        })
        // 'update'
        const _url = 'merchantTabbarDetail/save'
        // console.log('_url', _url, _data,that.compList2)
        // return
        that.$http.post(_url, _data[0]).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '保存成功',
              showClose: true
            })
            // that.getAssemblyList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        }).catch(function (error) {
        })
      })
    },


  }
}
</script>

<style lang="scss" scoped>
.decoration-page {
  box-sizing: border-box;
  padding: 16px 16px 0px 6px;
  width: 100%;
  height: 70%;
  background-color: #efefef;
}

.designer-cnt {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  .manage_left{
    width: 70%;
    height: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    .targetEl {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;//calc(100% - 80px);
      height: 90px;
      // margin-top: 20px;
      box-sizing: border-box;
      text-align: center;
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .display-body {
    // width: 28%;
    min-width: 375px;
    min-height: 723px;
    // height: calc(100% - 110px);
    height: 100%;
    position: relative;
    padding-bottom: 100px;
    box-sizing: border-box;
    overflow-y: auto;

    .cardDrag-container {
      width: 375px;
      // min-height: 723px;
      height: 100%;
      padding: 0 40px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 0;
      }

    }

  }

  .attr-layer {
    width: 30%; //32%
    min-width: 480px;
    background-color: #fefefe;
    display: flex;


    .attr-detail {
      width: 100%;
      height: 100%;
      overflow: auto;

      .attr-item-box {
        padding: 6px 10px;
        margin-bottom: 10px;

        .attr-item-typedata {
          .attr-item-label {
            margin-bottom: 5px;
          }

          .attr-item-value {
            .temp-box {
              display: flex;
              flex-wrap: wrap;

              .temp-item {
                width: calc((100% - 40px)/4);
                height: 90px;
                margin: 0 5px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .temp-item-img {
                  width: 48px;
                  height: 48px;
                  margin-bottom: 8px;
                }

                .temp-item-name {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 20px;
                  text-align: center;
                  color: #333;
                }
              }

              .active_temp-item {
                .temp-item-name {
                  color: #155bd4;
                }
              }
            }

            .addImgList {
              width: 100%;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;

              .img_info {
                color: #969799;
                font-weight: 400;
                margin-top: 8px;
                white-space: pre-wrap;
                font-size: 13px;
              }

              .imgList_box {
                // padding: 12px 0;
                width: 100%;
                box-sizing: border-box;

                .imgList-item {
                  border: 1px solid #e0e0e0;
                  margin: 12px 0;
                  padding: 4px;
                  box-sizing: border-box;
                  display: flex;

                  .ii-img-box {
                    width: 80px;
                    height: 100px;
                    position: relative;

                    .ii-img {
                      width: 100%;
                      height: 100%;
                    }

                    .ii-img-btn {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      width: 100%;
                      height: 20px;
                      background-color: rgba($color: #000000, $alpha: .5);
                      text-align: center;
                      font-size: 13px;
                      color: #ffffff;
                      cursor: pointer;
                    }
                  }

                  .ii-link-box {
                    width: calc(100% - 80px);
                    box-sizing: border-box;
                    height: 100px;
                    padding: 0 8px;

                    .ii-link-info {
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 20px;
                      color: #999;
                    }

                    .ii-link {}
                  }
                }
              }

              .upload_btn {
                background: #efefef;
                border-radius: 2px;
                padding: 6px 10px 6px 14px;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                width: -webkit-fit-content;
                width: -moz-fit-content;
                width: fit-content;
                margin: 0 auto;
                color: #333;
                cursor: pointer;
              }
            }
          }
        }

        .attr-item-typestyle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .attr-item-label {
            color: #969799;
            margin-right: 12px;
          }

          .attr-item-on {
            color: #333333;
            margin-right: 8px;
            font-size: 12px;
          }

          .attr-item-value {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }

      }
    }
  }
}

/deep/.el-collapse-item__content {
  padding-bottom: 0;
}

.left-drag-container div span {
  display: inline-block;
  width: 100% !important;
  height: calc(100vh - 180px) !important;
}

.cardDrag-list-wrap {
  display: inline-block;
  width: 100%;
  height: 100%;

  .comp-item {
    cursor: grab;
  }

  .active_comp {
    border: 1px solid #155bd4;
    // box-shadow: 0 0 5px #155bd4;
  }
}

/deep/.el-radio-button--small .el-radio-button__inner {
  padding: 4px 8px;
  height: 32px;
  min-width: 36px;
  line-height: 24px;
}

.assembly_img {
  width: 40px;
  height: 40px;
  overflow: hidden;
}
</style>
